module.exports = __webpack_public_path__ + "media/images/events-share-d683199af84f462d118a9aa034ca0300.png";